import React, { createContext, useContext, useEffect, useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { auth } from "../firebase";
import axios from 'axios';
import { set } from "react-hook-form";
import { jwtDecode } from "jwt-decode";
import { use } from "react";


const userAuthContext = createContext();

let tokenExpired = false;
const localSaveNameForTranscriptCollection = 'unsavedDataTranscript';
const localSaveNameOFDataLocal = 'unsavedDatauserDataLocal';

export function UserAuthContextProvider({ children }) {
  const [user, setUser] = useState({});
  const [signInStatus, setSignInStatus] = useState(false);
  const [useravatar, setUseravatar] = useState({});
  const [userToken, setUserToken] = useState(null);
  const [userDataLocal, setUserDataLocal] = useState(null);
  const [userVipLevel, setUserVipLevel] = useState(0);
  const [needUpdate, setNeedUpdate] = useState(false);
  const [openPricePopup, setOpenPricePopup] = useState(false);
  const [errorInfo, setErrorInfo] = useState(null);
  const [needResetGPTPrompt, setNeedResetGPTPrompt] = useState(false);
  const [needResetAilaunchmode, setNeedResetAilaunchmode] = useState(false);

  // if true means user clicked purchase button
  const [purchaseBtnClicked, setPurchaseBtnClicked] = useState(false); 
  // if true means frontend will start check payment update from backend(firestore)
  const [shouldCheckPaymentUpdate, setShouldCheckPaymentUpdate] = useState(false);  
  // only set it to true when VIPLevel is updated(means payment is updated)
  const [vipLevelUpdatedConfirmed, setVipLevelUpdatedConfirmed] = useState(false);
  const [renewPaymentMethodConfirmed, setRenewPaymentMethodConfirmed] = useState(false);
  const [purchaseURLCreated, setPurchaseURLCreated] = useState(false);
  const [updatedSuccessfully, setUpdatedSuccessfully] = useState(false);  
  const [needUpdateFromLocalStorageByAuth, setNeedUpdateFromLocalStorageByAuth] = useState(true);
  const [needUpdateUnsavedData, setNeedUpdateUnsavedData] = useState(true);
  const [needUpdateUnsavedDataOFTranscriptCollection, setNeedUpdateUnsavedDataOFTranscriptCollection] = useState(true);
  const [downgradeToFreeUser, setDowngradeToFreeUser] = useState(false);
  const [isOfflineTranscribing, setIsOfflineTranscribing] = useState(false);
  const [transcriptDataBuffer, setTranscriptDataBuffer] = useState([]);
  //2024.12.18 variable for offline transcribe task information
  //[{id: id, url: url, email: useremail, duration: duration, endTime: endTimeOfAudio, realtimeValue: realTimeFlag}, ...]; 
  const [taskIDOfOfflinetranscribe, setTaskIDOfOfflinetranscribe] = useState([]);
  //2024.12.19 variable for createHistory data snapshot
  //[{ inputValue, usageSum, endTime, realtimeBoolValue, transcribeID, url },...];
  const [dataSnapForCreateHistory, setDataSnapForCreateHistory] = useState([]); 
  const [currentUpdateReason, setCurrentUpdateReason] = useState(null);
  const [historyUpdatedSuccessfully, setHistoryUpdatedSuccessfully] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async(currentuser) => {
      if (currentuser) {
        setSignInStatus(true);
        setUser(currentuser);
        setUseravatar(currentuser.photoURL);
        try {
          const token = await currentuser.getIdToken();
          setUserToken(token);
          localStorage.setItem('usertokenForCheck', token);
          setNeedResetGPTPrompt(true);
          setNeedResetAilaunchmode(true);
          // console.log("User email", currentuser.email);
          // 其他逻辑
        } catch (error) {
          console.error('Error getting ID token:', error);
          handleLoginClick();
        }
      } else {
        setUser(null);
        setSignInStatus(false);
        setUseravatar(null);
        setUserToken(null);
        // setUserDataLocal(null);
        setNeedUpdate(false);
        setUserVipLevel(0);
        setNeedResetGPTPrompt(false);
        setNeedResetAilaunchmode(false);
      }
    })

    return () => {
      unsubscribe();
    };
  }, []);

  const handleLoginClick = () => {
    // console.log("handleLoginClick running")
    // setShowLoginPopup(true);
    logOut();
    window.location.href = '/login';
  }

  const refreshToken = async () => {
    if (user) {
      try {
        const token = await user.getIdToken(true); // 强制刷新令牌
        setUserToken(token);
        localStorage.setItem('usertokenForCheck', token);
        // console.log('Refreshed token:', token);
        return token;
      } catch (error) {
        console.error('Error refreshing token:', error);
        tokenExpired = true;
        return null;
      }
    }
  };

  const checkToken = async () => {
    const token = localStorage.getItem('usertokenForCheck');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        // Check if the token has expired
        if (decoded.exp < currentTime) {
          // console.log('Session expired. Fetch a new token.');
          tokenExpired = true;
          const token = await refreshToken(); // 主动刷新令牌
          return token;
        } else {
          // console.log('Token is valid. decoded.exp is:', decoded.exp, 'currentTime is:', currentTime);
          tokenExpired = false;
          return userToken;
        }
      } catch (error) {
        console.error('Error decoding token:', error);
        tokenExpired = true;
        return null;
      }
    } else {
      // No token found, redirect to login
      console.error('No token found. Need login.');
      tokenExpired = true;
      return null;
    }
  };


  useEffect(() => {
    if (user && userToken && !tokenExpired) {
      checkOrCreateUser(userToken);
      // listenToUserDataChange(user.uid);
    }
  }, [userToken]);

  useEffect(() => {
    if (userDataLocal && userDataLocal !== "null" && needUpdate) {
      localStorage.setItem('localSaveduserDataLocal', JSON.stringify({localUserDataLocal: userDataLocal}));
    } else if (userDataLocal && userDataLocal !== "null") {
      if((userDataLocal?.History === null || userDataLocal.History === undefined || userDataLocal?.History?.length === 0 || !userDataLocal?.History) && !historyUpdatedSuccessfully) {
        getHistory(userDataLocal);
      }
      let localUserData = localStorage.getItem('localSaveduserDataLocal')
      console.log("userDataLocal is:", userDataLocal);  
      if (localUserData) {
        const { localUserDataLocal } = JSON.parse(localUserData);
        if(localUserDataLocal?.Email !== user.email) {
          localStorage.setItem('localSaveduserDataLocal', JSON.stringify({localUserDataLocal: userDataLocal}));
        }
      } else {
        localStorage.setItem('localSaveduserDataLocal', JSON.stringify({localUserDataLocal: userDataLocal}));
      }
    }
  }, [userDataLocal, needUpdate, historyUpdatedSuccessfully]);

  useEffect(() => {
    if (user && userToken && !tokenExpired) {
      let localUserData = localStorage.getItem('localSaveduserDataLocal')
      if (localUserData) {
        setNeedUpdate(false);
        const { localUserDataLocal } = JSON.parse(localUserData);
        // console.log("localUserDataLocal is:", localUserDataLocal);  
        if(localUserDataLocal?.Email === user.email) {
          setUserDataLocal (localUserDataLocal);
          setUserVipLevel(localUserDataLocal.VIPLevel);
        }
      }
      if (transcriptDataBuffer.length > 0) {
        if (transcriptDataBuffer[0] !== user.uid) {
          // 如果第一个元素有值且不等于 user.uid，则更新第一个元素
          setTranscriptDataBuffer([user.uid, ...transcriptDataBuffer.slice(1)]);
        }
      } else {
        // 如果第一个元素没有值，则将 user.uid 作为第一个元素加入进去
        setTranscriptDataBuffer([user.uid]);
      }
    }
  }, [user]);

  useEffect(() => {
    if (needUpdateFromLocalStorageByAuth && user) {
      updateFromLocalStorage(user);
  //     // console.log("userDataLocal changed, it is:", userDataLocal);
  //     console.log("userDataLocal changed, Current time is: ", new Date().toLocaleString());
  //     // let purchaseHistoryArrayNew = userDataLocal.Purchasehistory;
  //     // let newestPurchasedHistoryNew = purchaseHistoryArrayNew.slice(-1)[0]; //use the newest purchase history
  //     // let createdTime = newestPurchasedHistoryNew.SubscriptionDetailBody.data.attributes.created_at.toString();
  //     // console.log("Test create date is: ", getEquivalentOrNextMonthTime(createdTime));

  //     // const input = '2025-01-31T00:00:01.000000Z';
  //     // console.log("Test 2025-01-31T00:00:01.000000Z month expired date is: ", getEquivalentOrNextMonthTime(input));

  //     // const input2 = '2025-03-13T00:00:00.000000Z';
  //     // console.log("Test 2025-03-13T00:00:00.000000Z month expired date is: ", getEquivalentOrNextMonthTime(input2));
    }
  }, [needUpdateFromLocalStorageByAuth, user]);

  useEffect(() => {
    if(!needUpdateUnsavedData && !needUpdateUnsavedDataOFTranscriptCollection) {
      setNeedUpdateFromLocalStorageByAuth(false);
    }
  }, [needUpdateUnsavedData, needUpdateUnsavedDataOFTranscriptCollection]);

  // 在页面加载时检查 localStorage 2024.06.04 //2024.12.05 recover data from localStorage
  const updateFromLocalStorage = (user) => {
    const unsavedDataOFTranscriptCollection = localStorage.getItem(localSaveNameForTranscriptCollection);
    const unsavedData = localStorage.getItem(localSaveNameOFDataLocal);
    if (unsavedData) {
      const { uid, noteBody } = JSON.parse(unsavedData);
      // 异步更新服务器
      if (uid === user.uid) {
        updateUserFirestoreData(noteBody).then(() => {
          // 删除 localStorage 中的数据
          setNeedUpdate(true);
          setCurrentUpdateReason('recoverDataFromLocalStorage');
          localStorage.removeItem(localSaveNameOFDataLocal);
          setNeedUpdateUnsavedData(false);
        });
      } 
    } else {
      setNeedUpdateUnsavedData(false);
    }

    if (unsavedDataOFTranscriptCollection) {
      const { uid, noteBody } = JSON.parse(unsavedDataOFTranscriptCollection);
      // 异步更新服务器
      if (uid === user.uid) {
       updateTranscriptionData(noteBody).then(() => {
          // 删除 localStorage 中的数据
          localStorage.removeItem(localSaveNameForTranscriptCollection);
          setNeedUpdateUnsavedDataOFTranscriptCollection(false);
        });
      } 
    } else {
      setNeedUpdateUnsavedDataOFTranscriptCollection(false);
    }
  }

  useEffect(() => {
    if(needUpdate) {
      // console.log("needUpdate changed to true, calling updateFirestore");
      updateFirestore();
      } else {
        // console.log("needUpdate changed to false, no need calling updateFirestore");
    }
  }, [needUpdate]);

  useEffect(() => {
    let intervalId;
  
    if (shouldCheckPaymentUpdate && userToken) {
      intervalId = setInterval(() => {
        checkOrCreateUser(userToken);
        console.log('checkOrCreateUser is called every 5 seconds')
      }, 5000); // 每隔5秒调用一次checkOrCreateUser函数
    } else if(!shouldCheckPaymentUpdate && intervalId) {
      clearInterval(intervalId);
    }
  
    return () => {
      if (intervalId) {
        clearInterval(intervalId); // 当组件卸载时，停止定时器
      }
    };
  }, [shouldCheckPaymentUpdate]);

  function logIn(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }
  function signUp(email, password) {
    return createUserWithEmailAndPassword(auth, email, password);
  }
  async function logOut() {
    try {
      await signOut(auth);
      // Sign-out successful.
      setUser(null);
      setSignInStatus(false);
      setUseravatar(null);
      setUserToken(null);
      setUserDataLocal(null);
      setNeedUpdate(false);
      setUserVipLevel(0);
      setNeedResetGPTPrompt(false);
      setNeedResetAilaunchmode(false);
    } catch (error) {
      // An error happened.
      console.log(error);
    }
    // return signOut(auth);
  }
  function googleSignIn() {
    const googleAuthProvider = new GoogleAuthProvider();
    return signInWithPopup(auth, googleAuthProvider);
  }

  const checkOrCreateUser = async (token) => {
    try {
      const response = await axios({
        url: '/api/checkOrCreateUserRecord',
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        data: {
          uid: user.uid,
          displayName: user.displayName || user.email,
          email: user.email,
        },
      });
      if (response.status === 200) {
        const userData = response.data;
        
        if((userDataLocal === null || userDataLocal==='null') && !shouldCheckPaymentUpdate) {
          setUserDataLocal(userData);
          setUserVipLevel(userData.VIPLevel);
        } else if (userData.Purchasehistory) { 
          let purchaseHistoryArrayNew = userData.Purchasehistory;
          let newestPurchasedHistoryNew = purchaseHistoryArrayNew.slice(-1)[0]; //use the newest purchase history
          let currnetPlanVariantIDNew = newestPurchasedHistoryNew.SubscriptionDetailBody.data.attributes.variant_id.toString();
          const renewTime = newestPurchasedHistoryNew.SubscriptionDetailBody.data.attributes.renews_at;
          const SubscriptionCreatedTime = newestPurchasedHistoryNew.SubscriptionDetailBody.data.attributes.created_at;
          const stauts = newestPurchasedHistoryNew.SubscriptionDetailBody.data.attributes.status;
          const SubscriptionUpdatedTime = newestPurchasedHistoryNew.SubscriptionDetailBody.data.attributes.updated_at;
          // const cardLast4 = newestPurchasedHistoryNew.SubscriptionDetailBody.data.attributes.card_last_four;
          const renewPaymentMethod = newestPurchasedHistoryNew.SubscriptionDetailBody.data.attributes.urls.update_payment_method;
          let newOrderOrNot = false;
          let updatedToday = false;
          const todayTime = new Date().toISOString();
          if(stauts === 'active' && formatDate(SubscriptionUpdatedTime) === formatDate(todayTime) && formatDate(SubscriptionCreatedTime) === formatDate(todayTime)) {
            newOrderOrNot = true;
            console.log("This is a new order, need to update VIPLevel");
          } else if(stauts === 'active' && formatDate(SubscriptionUpdatedTime) !== formatDate(todayTime)) {
            updatedToday = true;
            console.log("This order updated today");
          }

          // let checkLevelResult = await checkUserCurrentVariantID(currnetPlanVariantIDNew);
          
          // if ((userData.VIPLevel !== userDataLocal.VIPLevel || checkLevelResult) && newOrderOrNot && shouldCheckPaymentUpdate) {
          if ((userData.VIPLevel !== userDataLocal.VIPLevel && userData.VIPLevel > 0) && newOrderOrNot && shouldCheckPaymentUpdate) {
            setVipLevelUpdatedConfirmed(true); //means VIPLevel is updated and confirmed by frontend
            setTimeout(() => {
              setUserDataLocal(userData);
              setUserVipLevel(userData.VIPLevel);
              setShouldCheckPaymentUpdate(false);   //only set it to false when VIPLevel is updated(means payment is updated)
            }, 3); //3ms
          } else {
            let checkPaymentMethod = await checkRenewPaymentMethod(renewPaymentMethod);
            if((userData.VIPLevel === userDataLocal.VIPLevel && userData.VIPLevel > 0 && checkPaymentMethod) && updatedToday && shouldCheckPaymentUpdate){
              setRenewPaymentMethodConfirmed(true); //means VIPLevel is updated and confirmed by frontend
              setTimeout(() => {
                setUserDataLocal(userData);
                setUserVipLevel(userData.VIPLevel);
                setShouldCheckPaymentUpdate(false);   //only set it to false when VIPLevel is updated(means payment is updated)
              }, 3); //3ms
            }
          } 
        }
        
        // console.log("User data:", userData);
      } else {
        // console.error("Failed to fetch user data");
        setUserDataLocal(null);
        setErrorInfo("Failed to fetch user data");
      }
    } catch (error) {
      // console.error("Error fetching user data:", error);
      setUserDataLocal(null);
      setErrorInfo(error);
    }
  };

  // check user vip level
  const checkUserCurrentVariantID = async(purchaseID) => {

    if(!userDataLocal.Purchasehistory){
      console.log('userDataLocal.Purchasehistory is null, return true-it means current user did not has any payment history, need to update VIPLevel');
      return true;
    } 

    let purchaseHistoryArray = userDataLocal.Purchasehistory;
    let newestPurchasedHistory = purchaseHistoryArray.slice(-1)[0]; //use the newest purchase history

    const currnetPlanVariantID = newestPurchasedHistory.SubscriptionDetailBody.data.attributes.variant_id.toString();
    // const currentPlanVariantName = body.data.attributes.variant_name;
    if(purchaseID === currnetPlanVariantID) {
      console.log('purchaseID === currnetPlanVariantID, they are the same id:', purchaseID, currnetPlanVariantID)
      return false;
    } else {
      console.log('purchaseID !== currnetPlanVariantID, they are different id:', purchaseID, currnetPlanVariantID)
      return true;
    }
  }

  const checkRenewPaymentMethod = async(renewPaymentMethod) => {

    if(!userDataLocal.Purchasehistory){
      console.log('userDataLocal.Purchasehistory is null, return true-it means current user did not has any payment history.');
      return true;
    } 

    let purchaseHistoryArray = userDataLocal.Purchasehistory;
    let newestPurchasedHistory = purchaseHistoryArray.slice(-1)[0]; //use the newest purchase history

    const currnetRenewPaymentMethod = newestPurchasedHistory.SubscriptionDetailBody.data.attributes.urls.update_payment_method;
    // const currentPlanVariantName = body.data.attributes.variant_name;
    if(renewPaymentMethod === currnetRenewPaymentMethod) {
      console.log('renewPaymentMethod === currnetRenewPaymentMethod, they are the same, it means renew payment faliure', renewPaymentMethod, currnetRenewPaymentMethod)
      return false;
    } else {
      console.log('renewPaymentMethod !== currnetRenewPaymentMethod, they are different, it means renew payment successfully!', renewPaymentMethod, currnetRenewPaymentMethod)
      return true;
    }
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
  };

  //updateHistory 
  const updateHistory = async (note) => {
    const token = await checkToken();
    fetch('/api/updatehistory', {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(note),
    })
    .then(response => {
        if (response.ok) {
            console.log("History note updated successfully.");
            return Promise.resolve();
        } else {
            setUpdatedSuccessfully(false);
            console.log("Error updating History note.:", response); 
            return Promise.reject(new Error("Failed to update History note.")); // 返回 Promise 对象，以便在 catch 中捕获错误。
        }
    })
    .catch(error => {
        console.error("Error updating History note.:", error);
        setErrorInfo(error);
        return Promise.reject(error); // 返回 Promise 对象，以便在 catch 中捕获错误。
    });
  };

  //deleteHistory
  const deleteHistory = async (noteID) => {
    const history = userDataLocal?.History || [];
    const updatedNotes = history.filter(note => note.noteID !== noteID);
    setUserDataLocal({ ...userDataLocal, History: updatedNotes });
    // 2. 如果笔记有关联的视频ID和音频文件，可能需要清理这些资源
    const userToken = await checkToken();
    
    try {
      const response = await axios.delete(`/api/deletehistory/${noteID}`, {
        headers: {
          'Authorization': `Bearer ${userToken}`
        }
      });
      
      if (response.data.success) {
        console.log('Note deleted successfully!');
        // 可以在这里添加成功提示或刷新列表
        // return response.data;
      } else {
        console.error('Note deletion failed:', response.data.message);
        throw new Error(response.data.message || 'Delete failed');
      }
    } catch (error) {
      console.error('Error deleting note:', error.response?.data?.message || error.message);
      throw error;
    }
  }

  //getHistory 2025.04.16
  const getHistory = async (dataNow) => {
    const token = await checkToken();
    try {
      const response = await axios({
        url: '/api/gethistory',
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });
      if (response.status === 200 && response.data) {
        const historyData = response.data;
        console.log("History note get successfully.");
        const userData = {...dataNow, History: historyData};
        setUserDataLocal(userData);
        setHistoryUpdatedSuccessfully(true);
        return historyData;
      } else {
        console.log("Error getting History note.:", response);
        return null;
      }
    } catch (error) {
      console.error("Error getting History note.:", error);
      setErrorInfo(error);
      return null;
    }
  };
    
  // 更新用户云端数据（Firestore）的函数
  const updateFirestore = async () => {
    if(!needUpdate || userDataLocal === null) {
      // console.log("needUpdate is false or userDataLocal is null, no need to update Firestore");
      return; // 如果 needUpdate 为 false 或 userDataLocal 为 null，则直接返回。
    }

    const token = await checkToken();
    const userDataLocalwithoutHistory = {
      ...userDataLocal
    };
    if (userDataLocalwithoutHistory.History) {
      delete userDataLocalwithoutHistory.History;
    }

    //console.log("updateFirestore is called, fetching user data from Firestore");
    
    fetch('/api/updateUser', {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(userDataLocalwithoutHistory),
        // body: JSON.stringify(userDataLocal),
    })
    .then(response => {
        if (response.ok) {
            console.log("User information updated successfully.");
            setUpdatedSuccessfully(true);
            setNeedUpdate(false); // 更新完成后，将 needUpdate 设置为 false。
            return Promise.resolve();
        } else {
            console.error("Failed to update user information.");
            setUpdatedSuccessfully(false);
            console.log("error response:", response); 
            setNeedUpdate(false);
            
            // const unsavedData = localStorage.getItem('unsavedDatauserDataLocal');
            // if(unsavedData) localStorage.removeItem('unsavedDatauserDataLocal');
            // localStorage.setItem('unsavedDatauserDataLocal', JSON.stringify({ localUserDataLocal }));
            saveToLocalStorage(userDataLocal, localSaveNameOFDataLocal);
            return Promise.reject(new Error("Failed to update user information.")); // 返回 Promise 对象，以便在 catch 中捕获错误。
        }
    })
    .catch(error => {
        console.error("Error updating user information:", error);
        setUpdatedSuccessfully(false);
        setErrorInfo(error);
        setNeedUpdate(false);
        // let localUserDataLocal = userDataLocal;
        // const unsavedData = localStorage.getItem('unsavedDatauserDataLocal');
        // if(unsavedData) localStorage.removeItem('unsavedDatauserDataLocal');
        // localStorage.setItem('unsavedDatauserDataLocal', JSON.stringify({ localUserDataLocal }));
        saveToLocalStorage(userDataLocal, localSaveNameOFDataLocal);
        return Promise.reject(error); // 返回 Promise 对象，以便在 catch 中捕获错误。
    });
  };

  const saveToLocalStorage = (noteBody, localSaveName) => {
    const uid = user.uid;
    localStorage.setItem(localSaveName, JSON.stringify({ uid, noteBody }));
  };

  const updateVideoData = async (videoID, newVideoData) => {
    // const { Duration, Language, PolishedText, Title, Transcript } = videoData;
    const token = await checkToken();
      try {
      const response = await fetch('/api/updateVideoData', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          videoId: videoID,
          videoData: newVideoData
        }),
      });

      // if (response.ok) {
      //   console.log("Video data updated successfully.");
      //   return Promise.resolve();
      // } else {
      //   console.error("Failed to update videoData. error response:", response);
      //   return Promise.reject(new Error("Failed to update videoData."));
      // } subtitleWithTimestamp   AudioUrl         const audioName = data.audioName;
        // handleDeleteUploadedAudioFile(audioName);

      const data = await response.json();

      if (response.ok && data.success) {
        console.log("Video data updated successfully: ", data.message);
        return data;
      } else {
        throw new Error(data.error || "Failed to update videoData.");
      }
    } catch (error) {
      console.error("Error updating videoData:", error);
      return Promise.reject(error); 
    }
  };

  const handleDeleteUploadedAudioFile = async (audioName) => {
      if (!audioName) {
        console.error('No file to delete');
        return;
      }
  
      try {
        const userid = user.uid;
        const filename = audioName;
        const response = await axios.delete(`/api/upload/${userid}/${filename}`);
        console.log ('Delete uploaded audio file successfully!', response.data.message);
        // setUrl(null);
      } catch (err) {
        console.error(err);
      }
    };

  const updateTranscriptionData = async (note) => {
    // note: {noteID: "202106041200001", transcript: "This is a test transcription", polishedText:'', summary:'', gptresponse:''}
    const token = await checkToken();
    if (!note || !token) {
      console.error('Missing required parameters: note or token.');
      // return { success: false, error: 'Missing required parameters.' };
      let error = new Error('Missing required parameters.');
      return Promise.reject(error); 
    }

    let finalNote = note;

    if(!Array.isArray(note)) {
      let TandPandS = transcriptDataBuffer.find(item => item.noteID === note.noteID);
      if(!TandPandS) TandPandS = await fetchTrascriptionData(note.noteID);

      let renewSummary = true;
      let renewPolishedText = true;
      let renewKeywords = true;
      let renewTitle = true;
      let renewOutline = true;
      let renewTranscript = true;
      let renewGPTResponse = true;
      let renewInputValue = true;
      let renewMessage = true;
      let renewShortMemory = true;
      let renewSummaryOfChat = true;
      let renewSubtitleWithTimestamp = true;
      let revewTranscribeID = true;

      if (!note.summary || ((note?.summary?.includes('处理请求失败') || note?.summary?.includes('无法处理') || note?.summary?.includes('处理失败') || note?.summary?.includes('无法进行') || note?.summary?.includes('Failed to process the request')) && TandPandS?.summary)) {
        renewSummary = false;
      }
      if (!note.title || (note?.title === 'Title updating...' && TandPandS?.title)) {
        renewTitle = false;
      } 
      
      if (!note.outline || (note?.outline === 'Updating...' && TandPandS?.outline)){
        renewOutline = false;
      } 

      if (!note.keywords || (note?.keywords === 'Updating...' && TandPandS?.keywords)){
        renewKeywords = false;
      }

      if (!note.transcript && TandPandS?.transcript){
        renewTranscript = false;
      }

      if (!note.polishedText && TandPandS?.polishedText){
        renewPolishedText = false;
      }

      if (!note.gptresponse && TandPandS?.gptresponse){
        renewGPTResponse = false;
      }

      if (!note.inputValue && TandPandS?.inputValue){
        renewInputValue = false;
      }

      if (!note.message && TandPandS?.message){
        renewMessage = false;
      }

      if (!note.shortMemory && TandPandS?.shortMemory){
        renewShortMemory = false;
      }

      if (!note.summaryOfChat && TandPandS?.summaryOfChat){
        renewSummaryOfChat = false;
      }

      if (!note.subtitleWithTimestamp && TandPandS?.subtitleWithTimestamp){
        renewSubtitleWithTimestamp = false;
      }

      if (!note.transcribeID && TandPandS?.transcribeID){
        revewTranscribeID = false;
      } else if(note?.transcribeID ==='Done' && (!note.transcript || note?.inputValue === 'Transcript updating...' || (!note?.inputValue && TandPandS?.inputValue === 'Transcript updating...'))) {
        revewTranscribeID = false;
      }

      finalNote = {
        ...note,
        summary: renewSummary ? note?.summary : TandPandS?.summary,
        title: renewTitle ? note?.title : TandPandS?.title,
        outline: renewOutline ? note?.outline : TandPandS?.outline,
        keywords: renewKeywords ? note?.keywords : TandPandS?.keywords,
        transcript: renewTranscript ? note?.transcript : TandPandS?.transcript,
        polishedText: renewPolishedText ? note?.polishedText : TandPandS?.polishedText,
        gptresponse: renewGPTResponse ? note?.gptresponse : TandPandS?.gptresponse,
        inputValue: renewInputValue ? note?.inputValue : TandPandS?.inputValue,
        message: renewMessage ? note?.message : TandPandS?.message,
        shortMemory: renewShortMemory ? note?.shortMemory : TandPandS?.shortMemory,
        summaryOfChat: renewSummaryOfChat ? note?.summaryOfChat : TandPandS?.
        summaryOfChat,
        subtitleWithTimestamp: renewSubtitleWithTimestamp ? note?.subtitleWithTimestamp : TandPandS?.subtitleWithTimestamp,
        transcribeID: revewTranscribeID ? note?.transcribeID : TandPandS?.transcribeID,
      };
    }
    
    
    // || note?.keywords === 'Updating...' || !note.title || !note.outline || !note.keywords) && (!TandPandS || (TandPandS?.title === 'Title updating...' || TandPandS?.title === '' || TandPandS?.outline === 'Updating...' || TandPandS?.outline === '' || TandPandS?.keywords === 'Updating...' || TandPandS?.keywords === ''))))

    updateTranscriptionDataFromLocalStorage(finalNote);
    

    try {
      const response = await fetch('/api/updateTrascript', {
        method: 'POST',
        headers: {
          // 'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({note: finalNote, uid: user.uid}),
      });

      // const result = await response.json();
  
      if (response.ok) {
        console.log("Transcript updated successfully.");
        return Promise.resolve();
      } else {
        // console.error("Failed to update Transcript. error response:", response);
        console.log("Transcript update failed, stored locally.");
        saveToLocalStorage(note, localSaveNameForTranscriptCollection);
        return Promise.resolve();
      }
    } catch (error) {
      console.error("Error updating Transcript:", error);
      saveToLocalStorage(note, localSaveNameForTranscriptCollection);
      return Promise.reject(error); 
    }
  };

  const updateTranscriptionDataFromLocalStorage = async (note) => {
    const notesArray = Array.isArray(note) ? note : [note];
    for (const noteItem of notesArray) {
      const noteID = noteItem.noteID;
      const updatedData = noteItem;
      setTranscriptDataBuffer((prevBuffer) => {
        const noteExists = prevBuffer.some((item) => item.noteID === noteID);

        if (noteExists) {
          // 如果存在，则更新该元素
          return prevBuffer.map((item) =>
            item.noteID === noteID ? { ...item, ...updatedData } : item
          );
        } else {
          // 如果不存在，则追加该元素到数组
          return [...prevBuffer, { noteID, ...updatedData }];
        }
      });
    }
  };
  
  const fetchTrascriptionData = async (noteID) => {
    const token = await checkToken();
    try {
      const response = await axios({
        url: '/api/fetchTrascript',
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        data: {
          noteID: noteID,
        },
      });
      if (response.status === 200) {
        const transcriptData = response.data;
        // console.log("transcriptData:", transcriptData);
        return transcriptData;
      } else {
        console.error("Failed to fetch transcriptData");
        setErrorInfo("Failed to fetch transcriptData");
        return null;
      }
    } catch (error) {
      console.error("Error fetching transcriptData:", error);
      setErrorInfo(error);
      return null;
    }
  };

  //2025.01.18
  const getVideoData = async (videoId, videoUrl) => { 
    const token = await checkToken();
    try {
      const response = await axios({
        url: '/api/getVideoData',
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        data: {
          videoId: videoId,
        },
      });
      if (response.status === 200 && response.data) {
        const videoData = response.data;
        // console.log("videoData:", videoData);
        return videoData;
      } else {
        console.log ("Failed to fetch videoData or videoData is new so it need to create.");
        // setErrorInfo("Failed to fetch videoData");
        return null;
      }
    } catch (error) {
      console.error("Error fetching videoData:", error);
      setErrorInfo(error);
      return null;
    }
  };

  // 函数用于更新userDataLocal变量
  const updateUserFirestoreData = (newData) => {
    setUserDataLocal(prevData => ({...prevData, ...newData}));
    // console.log("updateUserFirestoreData is called, userDataLocal:", userDataLocal);
    return Promise.resolve();
  };

//————————————————————————————————————————————————————————————————————————————————————————
  // 查询所有批量任务
  const fetchBatchQueue = async () => {
    try {
      const token = await checkToken();
      const res = await axios.get('/api/batchqueue/list', {
        headers: { Authorization: `Bearer ${token}` }
      });
      return res.data.tasks;
    } catch (error) {
      console.error('Error fetching batch queue:', error);
      setErrorInfo(error);
      return [];
    }
  }

  // 新增或更新批量任务
  // const upsertBatchQueue = async (batchId, data) => {
  //   try {
  //     const token = await checkToken();
  //     await axios.post('/api/batchqueue/upsert', { batchId, data }, {
  //       headers: { Authorization: `Bearer ${token}` }
  //     });
  //     return true;
  //   } catch (error) {
  //     console.error('Error upserting batch queue:', error);
  //     setErrorInfo(error);
  //     return false;
  //   }
  // }

  const upsertBatchQueue = async (batchId, data) => {
    try {
      const token = await checkToken();
  
      // 1. 深拷贝 data，避免直接修改原始对象
      const payload = { ...data };
  
      // 2. 计算序列化后大小（字节）
      const jsonStr = JSON.stringify(payload);
      const sizeInBytes = new Blob([jsonStr]).size;
  
      // 3. 超过 1 MB 时，删除 transcripts 字段
      if (sizeInBytes > 1024 * 1024) {
        console.warn('Payload size exceeds 1 MB, removing transcripts field.');
        delete payload.transcripts;
      }
  
      // 4. 调用接口
      await axios.post(
        '/api/batchqueue/upsert',
        { batchId, data: payload },
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      return true;
    } catch (error) {
      console.error('Error upserting batch queue:', error);
      setErrorInfo(error);
      return false;
    }
  };

  // 删除批量任务
  const deleteBatchQueue = async (batchId, gptBatchId) => {
    try {
      const token = await checkToken();
      await axios.delete(`/api/batchqueue/${batchId}/${gptBatchId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return true;
    } catch (error) {
      console.error('Error deleting batch queue:', error);
      setErrorInfo(error);
      return false;
    }
  }

  return (
    <userAuthContext.Provider
      value={{ user, signInStatus, useravatar, userToken, userDataLocal, needUpdate, userVipLevel, 
        purchaseBtnClicked, setPurchaseBtnClicked, shouldCheckPaymentUpdate, setShouldCheckPaymentUpdate, 
        vipLevelUpdatedConfirmed, setVipLevelUpdatedConfirmed, setNeedUpdate, 
        updateUserFirestoreData, logIn, signUp, logOut, googleSignIn, openPricePopup, setOpenPricePopup, 
        purchaseURLCreated, setPurchaseURLCreated, errorInfo, setErrorInfo, needResetGPTPrompt, setNeedResetGPTPrompt,
        updatedSuccessfully, setUpdatedSuccessfully, needResetAilaunchmode, setNeedResetAilaunchmode, downgradeToFreeUser,
        setDowngradeToFreeUser, renewPaymentMethodConfirmed, setRenewPaymentMethodConfirmed, refreshToken, isOfflineTranscribing, 
        setIsOfflineTranscribing, updateTranscriptionData, fetchTrascriptionData, 
        needUpdateFromLocalStorageByAuth, setNeedUpdateFromLocalStorageByAuth, transcriptDataBuffer, setTranscriptDataBuffer, 
        taskIDOfOfflinetranscribe, setTaskIDOfOfflinetranscribe, dataSnapForCreateHistory, setDataSnapForCreateHistory, 
        updateVideoData, getVideoData, currentUpdateReason, setCurrentUpdateReason, checkToken, updateHistory, fetchBatchQueue,
        upsertBatchQueue, deleteBatchQueue, deleteHistory
     }}
    >
      {children}
    </userAuthContext.Provider>
  );
}

export function useUserAuth() {
  return useContext(userAuthContext);
}
